import { styled } from 'linaria/react';

export const GenerateCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 310px;

  @media (max-width: 440px) {
    height: calc(100vh - 80px);
  }
`;

export const GenerateCodeWrapper = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
